/* eslint-disable */
/* eslint-disable */
/* This component is a component that I developed and use when flexible dropdown is required. It was developed to be used with various projects hence it doesn't foollow specific conventions we use in CX. For this reason some linting rules are disabled constructable test is included and styles moved to another file though as per the rest of CX */

import { IconButton, ListSubheader, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import React, { Component } from 'react';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import autocompleteStyles from './Autocomplete.component.styles';

class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChange = this.onChange.bind(this);
    this.menuItemKeyDown = this.menuItemKeyDown.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (state.defaultValue !== props.defaultValue) {
      return {
        ...state,
        currentValue: props.defaultValue,
        defaultValue: props.defaultValue,
      };
    }
    return state;
  }

  onKeyDown(e) {
    // this is keydown for textfield
    const charCode = e.nativeEvent.which || e.nativeEvent.keyCode;

    if (charCode === 40) {
      // on arrow down focus first item but dont close the options
      this._canClose = false;
      if (this._firstItem) {
        setTimeout(() => {
          this._firstItem.focus();
        }, 0);
      }
    } else if (charCode === 9) {
      // on tab key close the options
      this.setState({ isOpen: false });
      this.props.onBlur(this.state.currentValue, this._inputRef);
    } else {
      this._canClose = true;
    }
  }

  onChange(e) {
    const { onType, validateFor } = this.props;

    const charCode = e.nativeEvent.which || e.nativeEvent.keyCode;
    if (
      charCode !== 37 &&
      charCode !== 38 &&
      charCode !== 39 &&
      charCode !== 40 &&
      charCode !== 46 &&
      charCode !== 8 &&
      (validateFor && !validateFor.test(e.target.value))
    ) {
      e.preventDefault();
      return false;
    }
    onType(e);
    this.setState({ currentValue: e.target.value, isOpen: true });
  }

  menuItemKeyDown(e) {
    // this is keydown event handler for menu options
    const charCode = e.nativeEvent.which || e.nativeEvent.keyCode;
    if (charCode === 9) {
      // on tab key close the options
      this.setState({ isOpen: false });
      this.props.onBlur(this.state.currentValue, this._inputRef);
    } else if (charCode !== 40 && charCode !== 38 && charCode !== 9 && charCode !== 16) {
      this._inputRef.focus();
    }
  }

  render() {
    const {
      id = '',
      autocompleteOff,
      options,
      onSelect,
      classes,
      onClear,
      label,
      onBlur,
      isLoading,
      error,
      inputClassesOpen,
      icon,
      endIcon,
      fullWidth,
      hideErrorLabel,
      placeholder,
      inputClasses,
      menuItemClasses,
      helperText,
      getInputRef, // gets called with reference to input so e.g. we can listen to its events directly from outside
      disabled,
      mandatoryFieldError,
    } = this.props;
    const { isOpen, currentValue } = this.state;
    const startAdornment = icon ? <span className={classes.icon}>{icon}</span> : <SearchIcon className={classes.icon} />;
    const endAdornment = endIcon ? (
      <span className={classes.icon}>{endIcon}</span>
    ) : (
      <InputAdornment position="end">
        {onClear && currentValue ? (
          <IconButton
            classes={{ colorInherit: classes.noPadding }}
            aria-label="Clear"
            color="inherit"
            edge="start"
            onClick={() => {
              this.setState({ currentValue: '' });
              onClear();
            }}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>
        ) : (
          ``
        )}
      </InputAdornment>
    );
    return (
      <ClickAwayListener
        onClickAway={() => {
          this.setState({ isOpen: false });
          if (isOpen) onBlur(currentValue, this._inputRef);
        }}
      >
        <div className={classes.mainContainer}>
          <FormControl error={!!error || mandatoryFieldError} fullWidth={fullWidth}>
            {label && <InputLabel htmlFor="component-error">{label}</InputLabel>}
            <Input
              placeholder={placeholder}
              className={options.length > 0 && isOpen ? inputClassesOpen : inputClasses}
              inputRef={(el) => {
                if (el) {
                  if (getInputRef && !this._inputRef) {
                    getInputRef(el);
                  }
                  this._inputRef = el;
                }
              }}
              disabled={disabled}
              onChange={this.onChange}
              value={currentValue || ``}
              onFocus={() => this.setState({ isOpen: true })}
              onKeyDown={this.onKeyDown}
              startAdornment={<InputAdornment position="start">{isLoading ? <CircularProgress className={classes.loading} /> : startAdornment}</InputAdornment>}
              endAdornment={endAdornment}
            />
            {error && !hideErrorLabel ? (
              <FormHelperText id="component-error-text">{error}</FormHelperText>
            ) : helperText ? (
              <FormHelperText id="component-error-text">{helperText}</FormHelperText>
            ) : null}
          </FormControl>

          {options.length > 0 && isOpen ? (
            <Paper classes={{ root: classes.paperRoot }}>
              <MenuList classes={{ root: classes.menuListRoot }} data-testid={`testid-autocomplete-${id}`}>
                {options.map((option, i) => {
                  return (
                    // Need to find better way of wrapping items with ListSubheader. Key is random for now till I find better spolution for this component. It is to ensure that when the list is modified it will not confuse items as by default, when key is not provided react will use array index
                    <div key={Math.random()}>
                      {option.subheader && (
                        <ListSubheader className={classes.listSubheader} data-testid={`testid-autocomplete-subheader-${option.subheader}`}>
                          <Typography variant="overline">{option.subheader}</Typography>
                        </ListSubheader>
                      )}
                      <MenuItem
                        data-testid={option.category ? `testid-autocomplete-option-category-${option.category}` : ''}
                        classes={{ root: menuItemClasses }}
                        onKeyDown={this.menuItemKeyDown}
                        onClick={() => {
                          onSelect(option, this._inputRef);
                          this.setState({
                            defaultValue: null,
                            isOpen: false,
                          });
                        }}
                      >
                        <div
                          ref={(el) => {
                            if (!i && el) {
                              this._firstItem = el.parentElement;
                            }
                          }}
                          className={classes.menuItemContent}
                        >
                          {option.component}
                        </div>
                      </MenuItem>
                    </div>
                  );
                })}
              </MenuList>
            </Paper>
          ) : null}
        </div>
      </ClickAwayListener>
    );
  }
}

export default withStyles(themeCreateInjectableStyles(autocompleteStyles), { withTheme: true })(Autocomplete);
